import { saveAs } from 'file-saver';

const downloadSvg = (svg: string, filename: string) => {
  const blob = new Blob([svg], {
    type: 'image/svg+xml;charset=utf-8',
  });
  saveAs(blob, `${filename}.svg`);
};

const downloadPng = (svg: string, filename: string, size = 512) => {
  const width = size;
  const height = size;
  const domParser = new DOMParser();
  const doc = domParser.parseFromString(svg, 'image/svg+xml');
  const xMLSerializer = new XMLSerializer();

  doc.documentElement.setAttribute('width', width.toString());
  doc.documentElement.setAttribute('height', height.toString());

  svg = xMLSerializer.serializeToString(doc);

  // create in-memory image
  const image = new Image();
  image.onload = () => {
    // create canvas
    const canvas = document.createElement('canvas');
    // define canvas size
    canvas.width = width;
    canvas.height = height;
    // draw svg (blob) to canvas
    const context = canvas.getContext('2d');
    if (context) {
      context.drawImage(image, 0, 0, width, height);
      // read PNG from canvas
      const png = canvas.toDataURL();
      // force browser to download
      saveAs(png, `${filename}.png`);
    } else {
      throw new Error('Unable to create 2d context on canvas.');
    }
  };
  image.src = 'data:image/svg+xml;base64,' + window.btoa(svg);
};

function downloadIcon(icon: Icon, options: { format: string; size?: number }, selectedFillColor) {
  if (!icon.svg) {
    throw new Error('Icon has no SVG code.');
  }

  const name = icon.filename ? icon.filename : icon.title;

  // trim file extension
  //TODO: replace again title with filename when filename is fixed from the backend
  let filename = name.replace(/\.[^.$]+$/, '');

  // append selectedFillColor to the filename
  if (selectedFillColor) {
    filename += `_${selectedFillColor}`;
  }

  if (options.format === 'SVG') {
    downloadSvg(icon.colorizedSvg || icon.svg, filename);
  } else if (options.format === 'PNG') {
    // for fixed svg sizes use the icons original width (fallback to height and then to 32 pixel)
    const size = options.size === 1 ? icon.width || icon.height || 32 : options.size;
    downloadPng(icon.colorizedSvg || icon.svg, filename, size);
  } else {
    throw new Error(`Unsupported download format: ${options.format}`);
  }
}

export default downloadIcon;
